import { t } from "i18next";
import { InfoPros, InfoType } from "interface/index";
import { resetStore } from "store/error";

export const infoHandler = (type:InfoType = "Error", title: string, description: string, actions?: any[]): InfoPros => {
    
    return {
        title,
        show: true,
        description,
        infoType: type,
        actions: actions ?? [
            {
                text: t("OK"),
                btn: resetStore,
                disabled: false,
                bgColor: "",
                textColor: "",
            },
        ],
    }
}
